import React from "react";
import TopoTexture from "@/components/TopoTexture";
import { ShieldCheck, Package, Wrench, Eye } from "lucide-react";
import { IMG } from "@/data/site";

const items = [
  { icon: <ShieldCheck className="w-5 h-5" />, title: "Floor & Wall Protection", text: "Padded floor runners, door jamb covers, and corner protectors on every move." },
  { icon: <Package className="w-5 h-5" />, title: "Careful Wrapping", text: "Furniture pads, shrink wrap, and protective blankets for all items, every time." },
  { icon: <Wrench className="w-5 h-5" />, title: "Proper Equipment", text: "Four-wheel dollies, appliance straps, ramps, and stair climbers — the right tool for every job." },
  { icon: <Eye className="w-5 h-5" />, title: "Attention to Detail", text: "From antiques to appliances, we handle every piece as if it were our own." },
];

const ProtectionSection = () => {
  return (
    <section data-testid="protection-section" className="py-20 md:py-32 bg-[var(--ct-primary)] text-white relative overflow-hidden">
      <TopoTexture variant="dark" opacity={0.05} />
      <div className="section-container relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-[0_30px_60px_rgba(0,0,0,0.3)]">
              <img
                src={IMG.whiteGlove}
                alt="Crosstown Movers careful handling - white glove moving Wyoming"
                className="w-full h-[460px] object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="label-xs text-[var(--ct-secondary)] mb-3">Premium Protection Standard</div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>
              Every move. Every item. Protected.
            </h2>
            <p className="mt-5 text-white/80 leading-relaxed max-w-xl">
              Our Wyoming movers treat your home and belongings with museum-level care. Floor protection,
              proper wrapping, and the right equipment are standard — not upsells.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              {items.map((it, i) => (
                <div key={i} className="p-5 rounded-2xl bg-white/5 border border-white/10 backdrop-blur" data-testid={`protection-${i}`}>
                  <div className="w-10 h-10 rounded-lg bg-[var(--ct-secondary)] flex items-center justify-center">
                    {it.icon}
                  </div>
                  <h3 className="mt-4 font-semibold" style={{ fontFamily: "Outfit" }}>{it.title}</h3>
                  <p className="mt-1 text-sm text-white/70 leading-relaxed">{it.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProtectionSection;
